 <app-card-medium title="{{ title | translate }}">
  <div class="content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div style="overflow: scroll; margin-bottom: .5em;">
        <div class="form-group">
          <input formControlName="name" type="text" class="form-control" placeholder="{{ 'Label*' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="brand" type="text" class="form-control" placeholder="{{ 'Brand*' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="model" type="text" class="form-control" placeholder="{{ 'Model*' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="manufacturing_year" type="text" class="form-control" placeholder="{{ 'Manufacturing Year*' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="serial_number" type="text" class="form-control" placeholder="{{ 'Serial Number*' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="weight" type="text" class="form-control" placeholder="{{ 'Weight (g)' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="length" type="text" class="form-control" placeholder="{{ 'Length (mm)' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="wingspan" type="text" class="form-control" placeholder="{{ 'Wingspan (mm)' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="power_source" type="text" class="form-control" placeholder="{{ 'Power Source' | translate }}">
        </div>
        <div class="form-group">
          <input formControlName="max_speed" type="text" class="form-control" placeholder="{{ 'Max Speed (m/s)' | translate }}">
        </div>
      </div>
      <div class="form-buttons">
        <!-- <button type="button" class="btn btn-sm btn-secondary" routerLink="/users">{{ 'Discard' | translate }}</button> -->
        <button type="submit" class="btn btn-sm btn-primary">{{ 'Save' | translate }}</button>
      </div>
    </form>  
  </div>
</app-card-medium>
